import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Synmio Store. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
